"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

export default function GoogleAnalytics() {
  const gaId = process.env.NEXT_PUBLIC_GA_ID || "G-4ZM3XP14NK";
  const [truendoReady, setTruendoReady] = useState(false);

  useEffect(() => {
    if (window.Truendo) {
      setTruendoReady(true);
      return;
    }

    const interval = window.setInterval(() => {
      if (window.Truendo) {
        window.clearInterval(interval);
        setTruendoReady(true);
      }
    }, 100);

    const timeout = window.setTimeout(() => {
      window.clearInterval(interval);
      setTruendoReady(true);
    }, 3000);

    return () => {
      window.clearInterval(interval);
      window.clearTimeout(timeout);
    };
  }, []);

  if (!truendoReady) {
    return null;
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          gtag('js', new Date());
          gtag('config', '${gaId}');
        `}
      </Script>
    </>
  );
}
